// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-label[data-v-bcb34dd4] {\n  display: inline-block;\n  width: 60px;\n  color: #666666;\n}\n.assembly-plan-detail-form .lable-blue[data-v-bcb34dd4]  .el-form-item__label {\n  color: blue !important;\n}\n.assembly-plan-detail-form .el-form-item[data-v-bcb34dd4] {\n  margin-left: 20px;\n}\n.el-form[data-v-bcb34dd4] .el-input__inner {\n  width: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
